import(/* webpackMode: "eager" */ "/home/pubky/cicd/actions-runner/_work/pubky-stack/pubky-stack/pubky-app/src/app/error.tsx");
